import React from 'react'
import Body from '../Components/Body'

const Home = () => {
  return (
    <div>
      <Body/>
    </div>
  )
}

export default Home
